interface II18nTexts {
  [key: string]: {
    [key: string]: string;
  };
}

const translationTexts: II18nTexts = {
  ko: {
    "main.loading": "로딩 중입니다.",
    "main.alreadySubmitting": "제출 중입니다.",
    "main.submitFailed": "제출에 실패했습니다.",
    "common.inputRequired": "필수",
    "common.inputMaxChoice": "최대 {{max}}개 선택",
    "common.successTitle": "제출 완료!",
    "common.fileMaxSize": "파일이 10MB를 초과합니다. 업로드할 수 없습니다.",
    "common.fileType": "지원하지 않는 파일 형식입니다.",
    "common.fileMaxCount": "파일은 최대 {{max}}개까지 업로드 가능합니다.",
    "formSurvey.successTitle": "제출 완료!",
    "formSurvey.successDescription": "설문조사에 참여해 주셔서 감사합니다.",
    "formSurvey.failTitle": "설문조사 참여 불가!",
    "formSurvey.failDescription": "진행 중인 설문조사가 아닙니다.",
    "formEvent.successTitle": "제출 완료!",
    "formEvent.successDescription": "이벤트에 참여해 주셔서 감사합니다.",
    "formEvent.failTitle": "이벤트 참여 불가!",
    "formEvent.failDescription": "진행 중인 이벤트가 아닙니다.",
    "promotion.successTitle": "제출 완료!",
    "promotion.successDescription": "프로모션에 참여해 주셔서 감사합니다.",
    "promotion.failTitle": "프로모션 참여 불가!",
    "promotion.failDescription": "진행 중인 프로모션이 아닙니다.",
    "collection.failDescription": "진행 중인 컬렉션이 아닙니다.",
    list: "목록",
  },
  en: {
    "main.loading": "Loading...",
    "main.alreadySubmitting": "Submitting...",
    "main.submitFailed": "Submission failed.",
    "common.inputRequired": "Required",
    "common.inputMaxChoice": "Select up to {{max}}",
    "common.successTitle": "Submission completed!",
    "common.fileMaxSize": "The file exceeds 10MB. It cannot be uploaded.",
    "common.fileType": "Unsupported file type.",
    "common.fileMaxCount": "You can upload up to {{max}} files.",
    "formSurvey.successTitle": "Submission completed!",
    "formSurvey.successDescription":
      "Thank you for participating in the survey.",
    "formSurvey.failTitle": "You can't participate in the survey!",
    "formSurvey.failDescription": "This is not an ongoing survey.",
    "formEvent.successTitle": "Submission completed!",
    "formEvent.successDescription": "Thank you for participating in the event.",
    "formEvent.failTitle": "You can't participate in the event!",
    "formEvent.failDescription": "This is not an ongoing event.",
    "promotion.successTitle": "Submission completed!",
    "promotion.successDescription":
      "Thank you for participating in the promotion.",
    "promotion.failTitle": "You can't participate in the promotion!",
    "promotion.failDescription": "This is not an ongoing promotion.",
    "collection.failDescription": "This is not an ongoing collection.",
    list: "List",
  },
  ja: {
    "main.loading": "ローディング。",
    "main.alreadySubmitting": "送信中です。",
    "main.submitFailed": "送信に失敗しました。",
    "common.inputRequired": "必須",
    "common.inputMaxChoice": "最大{{max}}個選択",
    "common.successTitle": "提出済み!",
    "common.fileMaxSize":
      "ファイルが10MBを超えています。アップロードできません。",
    "common.fileType": "サポートされていないファイル形式です。",
    "common.fileMaxCount": "ファイルは最大{{max}}個までアップロードできます。",
    "formSurvey.successTitle": "提出済み!",
    "formSurvey.successDescription":
      "アンケートにご参加いただきありがとうございます。",
    "formSurvey.failTitle": "アンケートに参加不可！",
    "formSurvey.failDescription": "進行中のアンケートではありません。",
    "formEvent.successTitle": "提出済み!",
    "formEvent.successDescription":
      "イベントにご参加いただきありがとうございます。",
    "formEvent.failTitle": "イベント参加不可！",
    "formEvent.failDescription": "進行中のイベントではありません。",
    "promotion.successTitle": "提出済み!",
    "promotion.successDescription":
      "プロモーションにご参加いただきありがとうございます。",
    "promotion.failTitle": "プロモーション参加不可！",
    "promotion.failDescription": "進行中のプロモーションではありません。",
    "collection.failDescription": "進行中のコレクションではありません。",
    list: "リスト",
  },
};

export default translationTexts;
